import { Component, inject, input, output, computed } from '@angular/core';
import { I18nService } from '../../services/i18n.service';
import { UiService } from '../../services/ui.service';
import { NzListModule } from 'ng-zorro-antd/list';
import { NavButtonComponent } from '../nav-button/nav-button';
import { SpinnerComponent } from '../spinner/spinner';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { AdditionalInfo } from '../../models/classes/additionalinfo';
import { UnitConversionPipe } from '../../pipes/unit-conversion.pipe';
import { Asset, AssetDetail } from '../../models/classes/asset';
@Component({
  selector: 'app-additional-info',
  imports: [NzListModule, NavButtonComponent, SpinnerComponent, NzIconModule, UnitConversionPipe],
  templateUrl: './additional-info.html',
  styleUrls: ['./additional-info.scss'],
})
export class AdditionalInfoComponent {
  addInfoValues = input<AdditionalInfo[]>([]);
  showLoadingSpinner = input<boolean>(false);
  asset = input<Asset | AssetDetail | null>();

  clickEdit = output<void>();

  public i18n = inject(I18nService);
  private ui = inject(UiService);

  private readonly steamRateCurrencyID = 17;
  private readonly pricePerTonID = 18;

  isMobile = computed<boolean>(() => this.ui.IsMobile());
  isTablet = computed<boolean>(() => this.ui.IsTablet());
  isDesktop = computed<boolean>(() => this.ui.IsDesktop());

  steamLossCurrencyUnit = computed<string>(() => {
    const values = this.addInfoValues() ?? [];
    const item = values.find((v) => v.categoryID === this.steamRateCurrencyID);
    if (!item || !item.text) return '€'; // default

    try {
      const parsed = JSON.parse(item.text);
      if (typeof parsed?.en === 'string') return parsed.en;
      const firstString = Object.values(parsed).find((v) => typeof v === 'string');
      return (firstString as string) ?? '€';
    } catch {
      // if not valid JSON, maybe raw symbol stored
      return typeof item.text === 'string' ? item.text : '€';
    }
  });

  /**
   * Helper predicate: is this additional info item representing "Price per Ton" (currency)?
   */
  isSteamCurrency = (addInfo: AdditionalInfo): boolean =>
    addInfo?.categoryID === this.pricePerTonID;

  onClickEdit(): void {
    this.clickEdit.emit();
  }
}
